var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMandatoryTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 101"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 11",
    cx: 9.99935,
    cy: 10.0013,
    rx: 7.33333,
    ry: 7.33333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5832 2.06222C15.9658 2.8605 17.1159 4.00603 17.9197 5.38541C18.7235 6.76479 19.1531 8.33017 19.166 9.92661C19.1789 11.523 18.7747 13.0952 17.9932 14.4874C17.2118 15.8795 16.0803 17.0435 14.7108 17.864C13.3413 18.6845 11.7812 19.1331 10.185 19.1654C8.58886 19.1977 7.01192 18.8126 5.61032 18.0482C4.20873 17.2838 3.03108 16.1665 2.19397 14.8071C1.35685 13.4477 0.8893 11.8932 0.837591 10.2976L0.833008 10.0006L0.837591 9.70355C0.888928 8.12046 1.3496 6.57768 2.17469 5.22563C2.99979 3.87357 4.16115 2.75838 5.54555 1.98878C6.92995 1.21917 8.49015 0.821416 10.074 0.834287C11.6579 0.847158 13.2115 1.27022 14.5832 2.06222ZM13.3979 7.51913C13.2401 7.36131 13.0301 7.26649 12.8073 7.25249C12.5845 7.23848 12.3643 7.30624 12.1879 7.44305L12.1017 7.51913L9.08311 10.5368L7.89784 9.35247L7.81168 9.27638C7.63529 9.13967 7.4151 9.07199 7.19237 9.08604C6.96965 9.10009 6.7597 9.19491 6.6019 9.35271C6.4441 9.51051 6.34928 9.72045 6.33523 9.94317C6.32118 10.1659 6.38886 10.3861 6.52558 10.5625L6.60166 10.6486L8.43502 12.482L8.52119 12.558C8.68195 12.6828 8.87964 12.7505 9.08311 12.7505C9.28658 12.7505 9.48427 12.6828 9.64503 12.558L9.7312 12.482L13.3979 8.8153L13.474 8.72913C13.6108 8.55276 13.6786 8.33253 13.6646 8.10976C13.6506 7.88699 13.5557 7.67698 13.3979 7.51913Z",
    fill: "#19BB7A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandatoryTick);
export default __webpack_public_path__ + "static/media/mandatory-tick.7c8975fbe4718f22463592256289684d.svg";
export { ForwardRef as ReactComponent };